import { connect } from 'react-redux'
import { selectAssignmentForSelectedTickets } from 'selectors/ticket_list'
import BulkAssignmentBadge from './view'

const select = state => ({
  assignment: selectAssignmentForSelectedTickets(state),
})

export default connect(select)(BulkAssignmentBadge)
